<template>
  <div>
    <div class="page-content" v-if="detailList">
  <!--    <NavBar
        class="nav-bar"
        ref="navBar"
        :title="title"
      ></NavBar>-->

      <div class="content-wrap">
        <div class="header">
          {{title}}
        </div>
        <div class="content">
          <div class="out-wrap-wrap box-wrap">

          </div>
          <div class="out-wrap  box-wrap">

          </div>
          <div class="box  box-wrap">
            <img src="~@/assets/active/test/header.png" alt="">
            <div class="box-content" v-if="detailList">
              <div class="title">
                <div class="prevTitle" v-show="prevShow" @click="prevTitle">上一题</div>
                <span class="number-wrap">{{curryIndex+1}}/{{detailList.length}}</span>
                : {{detailList[curryIndex].title}}
                <div class="img-wrap">
                  <img src="~@/assets/active/test/logo.png" alt="">
                </div>
              </div>
              <swiper
                :options="swiperOption"
                @slideChange="slideChange"
                @reachEnd="reachEnd"
                @slideChangeTransitionEnd="slideChangeTransitionEnd"
                ref="mySwiper"
                class="swiper-wrap swiper-no-swiping">
                <swiper-slide
                  class="swiper-no-swiping"
                  v-for="(item,index) in detailList"
                  :key="index">
                  <div class="swiper-no-swiping swiper-inner">
                    <div
                      class="btn"
                      v-for="(i,j) in item.funTopicAnswers"
                      :key="'item'+j"
                      @click="nextItem(index,j,i)">
                      {{i.answer}}
                    </div>
                  </div>
                </swiper-slide>
              </swiper>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { funQuestiontopics } from '@/api/adv';

export default {
  name: 'detail',
  data() {
    return {
      detailList: undefined, // 题目列表
      title: undefined, // 题目标题
      curryIndex: 0,
      scoreArray: [],
      prevShow: false,
      lastTitle: false, // 滚动到最后
      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction',
          loop: false,
          observeParents: true,
          noSwiping: true,
          noSwipingClass: 'stop-swiping',
        },
      },
    };
  },
  created() {
    this.getDetail();
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  methods: {
    sum(arr) {
      return arr.reduce((prep, curr) => prep + curr);
    },
    /**
     * 答题
     * @param index 问题位置
     * @param index2 答案位置
     * @param v 答案数据
     */
    nextItem(index, index2, v) {
      this.scoreArray[index] = v.score;
      if (this.lastTitle) {
        this.$router.push({
          name: 'ActiveTestResult',
          query: {
            subject: this.$route.query.subject,
            score: this.sum(this.scoreArray),
          },
        });
      } else {
        this.swiper.slideNext();
      }
      if (this.detailList.length === 1) {
        this.$router.push({
          name: 'ActiveTestResult',
          query: {
            subject: this.$route.query.subject,
            score: this.sum(this.scoreArray),
          },
        });
      }
    },
    slideChange(r) {
      console.log(r);
    },
    // 回调函数，swiper从一个slide过渡到另一个slide结束时执行。
    slideChangeTransitionEnd() {
      this.curryIndex = this.swiper.activeIndex;
      this.prevShow = this.swiper.activeIndex !== 0;
    },
    prevTitle() {
      this.swiper.slidePrev();
    },
    reachEnd() {
      this.lastTitle = true;
      console.log('到底了');
    },
    getDetail() {
      funQuestiontopics({ subject: this.$route.query.subject })
        .then((res) => {
          this.title = res.title;
          window.document.title = res.title;
          this.subject = res.subject;
          this.detailList = res.funTopics;
        });
    },
  },
};
</script>

<style scoped lang="scss">
  * {
    touch-action: none;
  }
  .header{
    position: relative;
    top:-60px;
    text-align: center;
    font-size: 36px;
    font-weight: bold;

  }
  .content-wrap {
    position: relative;
    height: 100%;
    background-image: url("~@/assets/active/test/bg.png");
    background-repeat: no-repeat;
    background-size: cover;
    padding: 140px 76px 87px 76px;

    .content {
      position: relative;
      height: 100%;
      width: 100%;

      .box-wrap {
        position: absolute;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 1);
      }

      .out-wrap-wrap {
        left: -23px;
        top: 22px;
        z-index: 1;
        border: 8px solid rgba(0, 0, 0, 1);
      }

      .out-wrap {
        top: 0;
        left: 0;
        z-index: 2;
        border: 8px solid rgba(0, 0, 0, 1);
      }

      .box {
        position: relative;
        left: 23px;
        top: -22px;
        z-index: 3;

        > img {
          display: block;
          width: 100%;
          height: 62px;
          position: absolute;
          top: 0;
          left: 0;
        }

        .box-content {
          height: 100%;
          border: 8px solid rgba(0, 0, 0, 1);

          .title {
            position: relative;
            padding: 134px 54px 72px 54px;
            border-bottom: 8px solid #000000;
            font-size: 36px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: bold;
            color: rgba(0, 0, 0, 1);
            line-height: 1.5;
            .number-wrap {
              display: inline-block;
              vertical-align: middle;
              background: rgba(0, 0, 0, 1);
              height: 44px;
              line-height: 45px;
              font-size: 28px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: rgba(255, 229, 41, 1);
              padding: 0 4px;
              text-align: center;
            }

            .img-wrap {
              position: absolute;
              bottom: -30px;
              right: 7px;
              padding: 0 34px;
              background-color: #ffffff;

              img {
                display: block;
                width: 60px;
                height: 60px;
              }
            }
          }

          .swiper-wrap {
            padding: 88px 0 70px 0;

            .swiper-inner {
              padding: 0 42px;
              text-align: center;

              .btn {
                height: 83px;
                border: 8px solid rgba(0, 0, 0, 1);
                font-size: 30px;
                font-weight: bold;
                color: rgba(0, 0, 0, 1);
                line-height: 70px;
                margin-bottom: 42px;
              }
            }
          }
        }
      }
    }
    .prevTitle{
      position: absolute;
      left: -1px;
      top: 52px;
      height:70px;
      padding: 0 56px;
      background:rgba(155,239,255,1);
      border-bottom:8px solid rgba(0,0,0,1);
      border-right:8px solid rgba(0,0,0,1);
      font-size:30px;
      font-weight:500;
      color:rgba(0,0,0,1);
      line-height:60px;
    }

  }
</style>
